import { render, staticRenderFns } from "./detailsOrderTable.vue?vue&type=template&id=2d0e7bfe&"
import script from "./detailsOrderTable.vue?vue&type=script&lang=js&"
export * from "./detailsOrderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports